import { equalHeights } from '../../General';

const BASE = '.offer-overview > .offer-teaser .offer-teaser__';

['header', 'text'].forEach((selector) => {
    equalHeights(BASE + selector);
});
